import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChangeoverSettingModel extends Model {
  @attr('boolean') enabled!: boolean;
  @attr('boolean') automatic!: boolean;

  @belongsTo('property', { inverse: 'changeoverSetting', async: false })
  property!: ModelRegistry['property'];

  @cached
  get manual(): boolean {
    return !this.automatic;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'changeover-setting': ChangeoverSettingModel;
  }
}
